import React from 'react';
import ContactForm from '../UserAccountMainPage/Components/PersonalInfoUpdateForm';

const EditPersonalInfoPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ContactForm />
      </div>
    </div>
  );
};

export default EditPersonalInfoPage;
